export default __webpack_public_path__ + "static/fig-c60d88878b67a64c7a45e6b52982429c.png";